import { render, staticRenderFns } from "./HabitDescription.vue?vue&type=template&id=7a3bee03&"
import script from "./HabitDescription.vue?vue&type=script&lang=js&"
export * from "./HabitDescription.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports